import { AppService } from '@app/app.service';
import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NotifierService } from '@services/notifier.service';
import { MoaConfig } from '@submodules/MOA/moa.config';

@Injectable()
export class MoaService extends AppService {
    public readonly _config: MoaConfig = inject(MoaConfig);

    private _renderer: Renderer2;

    /**
     * URL через который идут запросы на Yii
     */
    public serverYiiUrl: string;

    public settingsMOA: any;

    constructor(
        rendererFactory: RendererFactory2,
        private serviceNotifier: NotifierService,
    ) {
        super();

        this._renderer = rendererFactory.createRenderer(null, null);

        this.settingsMOA = this._config.settingsMOA;
        this.serverYiiUrl = this._config.urlYii;
    }

    // Загрузка ресурсов с MOA
    loadScript(): Promise<void> {
        return new Promise((resolve) => {
            const script = this._renderer.createElement('script');
            script.async = true;
            script.src = this._config.settingsMOA?.server_url + '/';
            script.src += this._config.settingsMOA?.js_resource;

            script.onload = () => resolve();
            script.onerror = () => {
                this.notify('error', this.language_dictionary?.notOpenEditorMOA);
            };

            this._renderer.appendChild(document.body, script);
        });
    }

    // Метод для взаимодействия с Нотификацией в рамках компонента MOA
    notify(type: string, message: string): void {
        this.serviceNotifier.notify(type, message);
    }
}
